<template>
    <div>
        <div
            v-if="workflow"
            class="modal-card"
        >
            <header class="modal-card-head">
                <p class="modal-card-title has-text-weight-medium">
                    {{ workflow.strDescription }}
                </p>
                <button
                    class="delete"
                    aria-label="close"
                    @click="$parent.close()"
                />
            </header>

            <section class="modal-card-body">
                <template v-if="hasTasks">
                    <p>
                        <strong>
                            These tasks are for you:
                        </strong>
                    </p>

                    <b-table :data="workflow.WorkFlowTasks">
                        <b-table-column
                            v-slot="props"
                            label="Tasks"
                        >
                            <span>
                                {{ props.row.strDescription }}
                                <b-icon
                                    v-if="props.row.blnCompleted === '1'"
                                    pack="fas"
                                    icon="check"
                                    type="is-success"
                                />
                            </span>
                        </b-table-column>
                    </b-table>
                </template>

                <p v-else-if="taskCount === 0">
                    No tasks have been assigned to you.
                </p>

                <Notification
                    v-if="! isAllTasksAssignedToUser"
                    class="mt-5"
                >
                    Our team are working to complete the other tasks.
                </Notification>
            </section>
        </div>

        <b-loading
            :is-full-page="true"
            :active="! workflow"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Notification from './Notification.vue';

export default {
    components: {
        Notification,
    },

    props: {
        workflowPk: {
            type: String,
            required: true,
        },
        tenancyPk: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            workflow: {},
        }
    },

    computed: {
        taskCount() {
            return (this.workflow.WorkFlowTasks ? this.workflow.WorkFlowTasks.length: 0);
        },

        hasTasks() {
            return Boolean(this.taskCount);
        },

        isAllTasksAssignedToUser() {
            return (parseInt(this.workflow.taskCount) === this.taskCount);
        },
    },

    mounted() {
        this.$store.dispatch('tenancyProperty/getWorkflow', this.workflowPk);

         return axios.get(`/api/contacts/tenancies/${this.tenancyPk}/workflows/${this.workflowPk}`)
            .then((response) => {
                this.workflow = response.data.data;
            })
            .catch(() => {
                this.workflow = {};
            });
    },
};
</script>

<style scoped>
    table.table thead
    {
        display: none;
    }
</style>
